const getVariation = (variationMap, id, variation) => variationMap && variationMap[id] === variation,

  hasEmptyExperiment = (variationMap) => variationMap && Object.keys(variationMap).length === 0

export {
  getVariation,
  hasEmptyExperiment,
}
